import { Globe } from "lucide-react";
import { useTranslation } from "@/i18n/LanguageContext";

/**
 * Simple language toggle showing "EN | ES" with active state.
 * `variant` controls sizing: "header" (default) or "mobile".
 */
export default function LanguageToggle({ variant = "header" }) {
    const { lang, setLang } = useTranslation();

    const base =
        "inline-flex items-center gap-2 rounded-full border border-border bg-cream/60 text-ink-soft hover:text-ink transition-colors";
    const size =
        variant === "mobile"
            ? "px-3 py-2 text-sm"
            : "px-3 py-2 text-xs font-semibold tracking-wide";

    const pill = (code, label) => {
        const active = lang === code;
        return (
            <button
                key={code}
                type="button"
                onClick={() => setLang(code)}
                data-testid={`lang-toggle-${code}`}
                aria-pressed={active}
                className={`rounded-full px-2.5 py-1 transition-colors ${
                    active
                        ? "bg-ink text-cream"
                        : "text-ink-soft hover:text-ink"
                }`}
            >
                {label}
            </button>
        );
    };

    return (
        <div
            data-testid="language-toggle"
            className={`${base} ${size}`}
            role="group"
            aria-label="Language selector"
        >
            <Globe size={14} className="text-ink-soft ml-1" aria-hidden="true" />
            {pill("en", "EN")}
            {pill("es", "ES")}
        </div>
    );
}
